import graphql__cf574c9b2ff3b1e5000f from "./__generated__/PageSectionSearchBox_pageSection.graphql.js";
import graphql__626b951f524c029d9e93 from "./__generated__/PageSectionSearchBoxQuery.graphql.js";import { useCallback } from "react";
import { useFragment } from "react-relay";
import { graphql } from "react-relay";
import { fetchQuery } from "react-relay";

import AsyncSelect from "../Select/AsyncSelect";
import appRelayEnvironment from "../../config/AppRelayEnvironment";
import { useNavigateTo } from "../Routes/RoutesContext";
import PageSectionBlockWithTitleAndDescription from "./PageSectionBlockWithTitleAndDescription";

const PageSectionSearchBox = props => {
  const pageSection = useFragment(PageSectionSearchBox_pageSection, props.pageSection);
  const { title, iconClass, description, searchConfiguration } = pageSection;
  const searchConfigurationId = searchConfiguration.id;
  const { displayOptionsByDefault } = searchConfiguration;

  const navigateTo = useNavigateTo();

  const handleChange = useCallback(
    ({ value }) => {
      if (value) navigateTo(value);
    },
    [navigateTo]
  );

  if (!searchConfigurationId) return;

  const loadOptions = terms =>
    fetchOptions(searchConfigurationId, terms, displayOptionsByDefault);
  const onChange = option => handleChange(option, props.history);

  return (
    <PageSectionBlockWithTitleAndDescription
      title={title}
      description={description}
      iconClassName={iconClass}
    >
      <div className="search-input-wrapper">
        <AsyncSelect
          className="react-select-search-box"
          classNamePrefix="react-select-search-box"
          loadOptions={loadOptions}
          defaultOptions={true}
          onChange={onChange}
          tabSelectsValue={false}
          openMenuOnFocus
        />
      </div>
    </PageSectionBlockWithTitleAndDescription>
  );
};

function fetchOptions(searchConfigurationId, terms, displayOptionsByDefault = false) {
  return new Promise(resolve => {
    if (!terms && !displayOptionsByDefault) return resolve([]);

    const environment = appRelayEnvironment;
    const variables = { searchConfigurationId, terms: terms || "" };

    return fetchQuery(environment, PageSectionSearchBoxQuery, variables).subscribe({
      next: data => resolve(data.searchResults.results)
    });
  });
}

const PageSectionSearchBox_pageSection = graphql__cf574c9b2ff3b1e5000f;

export default PageSectionSearchBox;

const PageSectionSearchBoxQuery = graphql__626b951f524c029d9e93;
